export const TASKS_COLLECTION_NAME = 'tasks'
